import { Dialog, 
         DialogTitle, 
         DialogContent,
         Grid,
         FormControl,
         InputLabel,
         Select,
         MenuItem,
         TextField,
         DialogActions,
         Button,
         Divider
       }                                                        from "@mui/material"
import { ServiceNodeData }                                      from "./CustomNode"
import { useSelector }                                          from "react-redux"
import { Node }                                                 from "@xyflow/react"
import { useEffect, useState } from "react"
import { selectNodes,
         selectSystemNodePositions
       }                                                    from "store/dataReducers/workflowSlice"
export interface CreateNewNodeProps {
  isAddNodeDialogOpen       : boolean,
  setIsAddNodeDialogOpen    : (isOpen : boolean) => void,
  selectExistingNode        : (node : Node<ServiceNodeData>) => void,
  addNewNode                : (nodeData : ServiceNodeData) => void,
}

export const CreateNewNode = (props : CreateNewNodeProps) => {

  const { isAddNodeDialogOpen, setIsAddNodeDialogOpen, 
          selectExistingNode, addNewNode
        } = props  

  const [allowedNodes, setAllowedNodes] = useState<Node<ServiceNodeData>[]>([])

  const [existingNode, setExistingNode] = useState<Node<ServiceNodeData>>()
  const [newNodeData, setNewNodeData] = useState<ServiceNodeData>()

  const nodes = useSelector(selectNodes)
  const sysNodePositions = useSelector(selectSystemNodePositions)

  const handleAddNode = () => {
    if (existingNode) {
      selectExistingNode(existingNode);
    } else {
      addNewNode(newNodeData!);
    }
  }

  useEffect(() => {
    
    const allowedNodes = []
    for (const node of nodes) {
      if (sysNodePositions.find(
          (nodePosition) => (nodePosition.systemNode as any).documentId === node.id) === undefined) {
        allowedNodes.push(node)
      }
    }

    setAllowedNodes(allowedNodes)

  }, [nodes, sysNodePositions])

  return (
    <Dialog open={isAddNodeDialogOpen} onClose={() => setIsAddNodeDialogOpen(false)}>
      
      <DialogTitle>Choose existing Node</DialogTitle>
      <DialogContent>
        <Grid container sx={{ mt: 1 }}>
          <Grid size={{xs: 12}} >
            <FormControl fullWidth>
              <InputLabel>Choose Node</InputLabel>
              <Select
                value={existingNode?.id || -1}
                label="Select Node"
                onChange={(e) => {

                  if (e.target.value === -1) {  
                    setExistingNode(undefined)
                  } else {
                    const selectedNode = nodes.find(node => node.id === e.target.value)!;
                    setExistingNode(selectedNode);
                  }
                }}
              >
                <MenuItem key={-1} value={-1}>
                  None
                </MenuItem>
                {allowedNodes.map((node) => (
                  <MenuItem key={node.id} value={node.id}>
                    {node.data.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />
      <DialogTitle>Add new Node</DialogTitle>
      <DialogContent>
        <Grid container rowSpacing={2}>
          <Grid size={{xs: 12}}>
            <FormControl fullWidth>
              <InputLabel>Node Type</InputLabel>
              <Select
                value={newNodeData?.type}
                label="Node Type"
                onChange={(e) => setNewNodeData({ ...newNodeData!, type: e.target.value as ServiceNodeData['type'] })}
              >
                <MenuItem value="storage">Storage</MenuItem>
                <MenuItem value="api">API</MenuItem>
                <MenuItem value="daemon">Daemon</MenuItem>
                <MenuItem value="pipeline">Pipeline</MenuItem>
                <MenuItem value="module">Module</MenuItem>
                <MenuItem value="product">Product</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              fullWidth
              label="Label"
              value={newNodeData?.label}
              onChange={(e) => setNewNodeData({ ...newNodeData!, label: e.target.value })}
            />
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              fullWidth
              label="Description"
              value={newNodeData?.description}
              onChange={(e) => setNewNodeData({ ...newNodeData!, description: e.target.value })}
              multiline
              rows={2}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsAddNodeDialogOpen(false)}>Cancel</Button>
        <Button onClick={handleAddNode} variant="contained">Add</Button>
      </DialogActions>
    </Dialog>
  )
}